import client from './axiosClient';
export const getProfile    = ()  => client.get('/profile');
export const updateProfile = dto => client.put('/profile', dto);
